import * as React from "react";
import { Navbar } from "reactstrap";
import { ReactComponent as Logo } from "./../icons/fence-svgrepo-com.svg";
import { EstimateApi } from "../api/api";
import { SessionStorageWrapper } from "../models/session-storage-wapper";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

type CompanyInfo = {
  name: string;
  street: string;
  city: string;
  zipcode: string;
  state: string;
  phone: string;
  email: string;
};

type HeaderProps = {
  portalId: string;
};

export default function Header(props: HeaderProps) {
  const [companyInfo, setCompanyInfo] = React.useState<CompanyInfo>();
  const navigate = useNavigate();

  React.useEffect(() => {
    EstimateApi.getCompanyInfo(props.portalId)
      .then((d) => {
        setCompanyInfo({
          name: d.name,
          street: d.street,
          city: d.city,
          state: d.state,
          zipcode: d.zipcode,
          phone: d.phone,
          email: d.email,
        });
        SessionStorageWrapper.addItem<string>("companyId", d.companyId);
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 404) navigate("/404");
        setCompanyInfo({ name: "FenceBuildr", street: "", city: "", state: "", zipcode: "", phone: "", email: "" });
      });
  }, [setCompanyInfo, navigate, props.portalId]);

  const rootUrl = `/${props.portalId}/designer`;

  return (
    <header className="bg-primary border-bottom border-secondary">
      <Navbar>
        <a href={rootUrl} className="navbar-brand d-flex align-items-center gap-2">
          <span className="bg-secondary rounded d-flex align-items-center justify-content-center p-1">
            <Logo width="22" height="18" />
          </span>
          <strong className="text-white">{companyInfo?.name}</strong>
        </a>

        {/* Desktop: full address */}
        <div className="d-none d-md-block text-white-50" style={{ fontSize: "11px", textAlign: "right" }}>
          {companyInfo?.street && (
            <>
              {companyInfo.street}<br />
              {companyInfo.city}, {companyInfo.state} {companyInfo.zipcode}<br />
              {companyInfo.phone} &nbsp;·&nbsp;{" "}
              <a href={`mailto:${companyInfo.email}`} className="text-warning">
                {companyInfo.email}
              </a>
            </>
          )}
        </div>

        {/* Mobile: phone link only */}
        {companyInfo?.phone && (
          <a href={`tel:${companyInfo.phone}`} className="d-flex d-md-none text-warning fw-bold small">
            {companyInfo.phone}
          </a>
        )}
      </Navbar>
    </header>
  );
}
